import { render, staticRenderFns } from "./AlarmLevelIcon.vue?vue&type=template&id=20b8df2a&scoped=true"
import script from "./AlarmLevelIcon.vue?vue&type=script&lang=js"
export * from "./AlarmLevelIcon.vue?vue&type=script&lang=js"
import style0 from "./AlarmLevelIcon.vue?vue&type=style&index=0&id=20b8df2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b8df2a",
  null
  
)

export default component.exports